import { useModal } from '@ebay/nice-modal-react'
import { Icon } from '@iconify/react'
import { BooleanParam, useQueryParam } from 'use-query-params'
import { useParams } from 'react-router-dom'

import {
  Button,
  Dropdown,
  Tooltip,
  useGetProjectDomain,
  useGlobalState,
} from '@pepper/ui'

import { useSelectedCompanyId } from 'utils/functions/misc'

import CTACard from 'container/Projects/LiveProjects/CTACard'

import s from './CreateKeywordsDropdown.module.css'

type Props = {
  onResearchKeywords: () => void
  onImportKeywords: () => void
}

export const CreateKeywordsDropdown = ({
  onResearchKeywords,
  onImportKeywords,
}: Props) => {
  const companyId = useSelectedCompanyId()
  const [_, setOpenLinkDomainModal] = useQueryParam('link_domain', BooleanParam)
  const { permissions } = useGlobalState()
  const { projectId } = useParams<{ projectId: string }>()
  const { show: showUpsellBanner } = useModal('buy-cmp')
  const { data: projectDomain } = useGetProjectDomain({
    data: {
      companyId,
      projectId,
    },
  })

  const isDomainLinked = projectDomain?.domain
  const isDomainRemoved = !!projectDomain?.domain?.deleted_at
  const hasKeywordsPermission = permissions?.keywords

  const menu = (
    <div className={s.wrapper}>
      <CTACard
        title="Discover Keywords ->"
        description="Dive into a sea of keyword ideas curated for you, or create your very own! 💡"
        icon={<Icon icon="lucide:loader" width={20} height={20} />}
        onClick={onResearchKeywords}
      />
      <CTACard
        title="Import your Keywords ->"
        description="Have a list ready? 📋 Create topics, SEO briefs, and start writing!"
        icon={<Icon icon="uil:file-upload-alt" width={20} height={20} />}
        onClick={onImportKeywords}
      />
    </div>
  )

  return (
    <>
      {isDomainLinked && isDomainRemoved && (
        <Tooltip
          title="Domain associated with this project has been removed"
          placement="left"
        >
          <Button
            type="primary"
            icon={<Icon icon="lucide:plus" width={16} height={16} />}
            className={s.disabledBtn}
          >
            Add Keywords
          </Button>
        </Tooltip>
      )}
      {hasKeywordsPermission && !isDomainLinked && (
        <Button
          type="primary"
          icon={<Icon icon="lucide:plus" width={16} height={16} />}
          onClick={() => setOpenLinkDomainModal(true)}
        >
          Add Keywords
        </Button>
      )}
      {!hasKeywordsPermission && !isDomainRemoved && (
        <Button
          type="primary"
          icon={<Icon icon="lucide:plus" width={16} height={16} />}
          onClick={() => showUpsellBanner({ id: 'keywords' })}
        >
          Add Keywords
        </Button>
      )}
      {hasKeywordsPermission && isDomainLinked && !isDomainRemoved && (
        <Dropdown overlay={menu} trigger={['click']} disabled={isDomainRemoved}>
          <Button
            type="primary"
            icon={<Icon icon="lucide:plus" width={16} height={16} />}
          >
            Add Keywords
          </Button>
        </Dropdown>
      )}
    </>
  )
}
